"use strict";

var _Fragment;
import { c as _c } from "react/compiler-runtime";
import { useLayoutEffect } from 'react';
import { GTM_WEB } from '@autoguru/global-configs';
import { Helmet } from 'react-helmet';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment2 } from "react/jsx-runtime";
export const SpaAnalyticsHead = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useLayoutEffect(_temp2, t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = _Fragment || (_Fragment = /*#__PURE__*/_jsx(_Fragment2, {
      children: /*#__PURE__*/_jsxs(Helmet, {
        children: [/*#__PURE__*/_jsx("link", {
          href: "https://www.google-analytics.com",
          rel: "preconnect",
          crossOrigin: "anonymous"
        }), /*#__PURE__*/_jsx("link", {
          href: "https://www.googletagmanager.com",
          rel: "preconnect",
          crossOrigin: "anonymous"
        }), /*#__PURE__*/_jsx("link", {
          href: "https://www.gstatic.com",
          rel: "preconnect",
          crossOrigin: "anonymous"
        }), /*#__PURE__*/_jsx("link", {
          href: "https://cdn.heapanalytics.com",
          rel: "preconnect",
          crossOrigin: "anonymous"
        })]
      })
    }));
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
function _temp(w, d, s, l, i) {
  w[l] = w[l] || [];
  w[l].push({
    "gtm.start": new Date().getTime(),
    event: "gtm.js"
  });
  const f = d.getElementsByTagName(s)[0];
  const j = d.createElement(s);
  const dl = l !== "dataLayer" ? `&l=${l}` : "";
  j.async = true;
  j.src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}`;
  f.parentNode.insertBefore(j, f);
}
function _temp2() {
  _temp(window, document, "script", "dataLayer", GTM_WEB);
}